<div fxLayout="column">
  <h1 mat-dialog-title>I have a request (or an issue)</h1>
  <div mat-dialog-content fxFlex="100">
    <form  (submit)="submit($event)" >
      <mat-form-field appearance="fill" fxFlex="100">
        <mat-label>Leave a request/Report an issue</mat-label>
        <textarea
          matInput
          placeholder="What I'm missing in this application is ..."
          value="{{feature}}"
          (input)="feature= $event.target.value"
        ></textarea>
      </mat-form-field>
      <button [disabled]="isSent" type="submit" mat-raised-button color="primary">Send</button>
    </form>
  </div>
</div>
